import { isUrl, cloneDeep, findParentPath, mapTree } from '@radical/utils'
import { Menu } from '@radical/types'

export function getAllParentPath<T = Recordable<any>>(
  treeData: T[],
  path: string,
) {
  const menuList = findParentPath(treeData, (n) => n.name === path) as Menu[]
  return (menuList || []).map((item) => item.name)
}

// 从route配置生成菜单
export function transformRouteToMenu(routeModList: RouteRecordItem[]) {
  const cloneRouteModList = cloneDeep(routeModList)
  const routeList: RouteRecordItem[] = []

  cloneRouteModList.forEach((item) => {
    // 当隐藏子菜单时，重定向到指定路由
    if (item.meta?.hideChildrenInMenu && typeof item.redirect === 'string') {
      item.path = item.redirect
    }
    // 单个显示
    if (item.meta?.single) {
      const realItem = item?.children?.[0]
      realItem && routeList.push(realItem)
    } else {
      routeList.push(item)
    }
  })
  // 筛选隐藏子菜单
  routeList.forEach((v) => {
    if (v.meta.hideChildrenInMenu) {
      delete v.children
    }
  })
  const list = mapTree(routeList, {
    conversion: (node: RouteRecordItem) => {
      const { meta: { hideMenu = false } = {} } = node

      return {
        ...(node.meta || {}),
        meta: node.meta,
        name: node.name,
        hideMenu,
        path: node.path,
        ...(node.redirect ? { redirect: node.redirect } : {}),
      }
    },
  })
  return cloneDeep(list)
}
